var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatients3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 416.83,
    cy: 77.06,
    r: 30.25,
    transform: "translate(217.39 451.1) rotate(-72.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.21,
    cy: 77.73,
    r: 28.86,
    transform: "translate(20.71 229.17) rotate(-31.39)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.21,
    cy: 77.73,
    r: 27.04,
    transform: "translate(20.77 229.32) rotate(-31.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.64,72c-12.31,7.46-32.55,19.7-43.86,26.41a27.08,27.08,0,0,1-7.39-9.94L430.8,53.79A27.07,27.07,0,0,1,444.64,72Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.23,78.67a26.72,26.72,0,0,1-1.78,8.79l-33.73,16a26.8,26.8,0,0,1-4.26-1.83C415.65,95.69,434.27,85,445.23,78.67Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.95,
    y: 52.65,
    width: 0.52,
    height: 4.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.44,
    y: 55.74,
    width: 0.52,
    height: 4.1,
    transform: "translate(25.59 211.08) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.01,
    y: 64.17,
    width: 0.52,
    height: 4.1,
    transform: "translate(141.76 378) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.14,
    y: 77.47,
    width: 4.1,
    height: 0.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.22,
    y: 88.98,
    width: 4.1,
    height: 0.52,
    transform: "translate(8.75 211.12) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.65,
    y: 97.41,
    width: 4.1,
    height: 0.52,
    transform: "translate(118.91 401.19) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.95,
    y: 98.71,
    width: 0.52,
    height: 4.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.47,
    y: 95.62,
    width: 0.52,
    height: 4.1,
    transform: "translate(8.74 227.95) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.9,
    y: 87.19,
    width: 0.52,
    height: 4.1,
    transform: "translate(141.77 424.06) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.19,
    y: 77.47,
    width: 4.1,
    height: 0.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.11,
    y: 65.96,
    width: 4.1,
    height: 0.52,
    transform: "translate(25.62 228.02) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.68,
    y: 57.53,
    width: 4.1,
    height: 0.52,
    transform: "translate(165.02 401.2) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.61 54.51 419.5 79.56 416.93 79.52 417.91 54.5 418.61 54.51",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.21 69 417.36 79.75 416.13 77.5 433.88 68.38 434.21 69",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.09,77.73a.88.88,0,1,1-.88-.88A.88.88,0,0,1,419.09,77.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.66,
    y: 233.81,
    width: 81.8,
    height: 148.95,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 233.81,
    width: 21,
    height: 148.95,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.72,
    y: 343.68,
    width: 73.69,
    height: 34.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,343.68c0,2.95-5.34,5.34-11.92,5.34s-11.92-2.39-11.92-5.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.72,
    y: 308.64,
    width: 73.69,
    height: 34.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,308.64c0,3-5.34,5.35-11.92,5.35s-11.92-2.39-11.92-5.35Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.72,
    y: 273.61,
    width: 73.69,
    height: 34.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,273.61c0,2.95-5.34,5.35-11.92,5.35s-11.92-2.4-11.92-5.35Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.72,
    y: 238.57,
    width: 73.69,
    height: 34.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,238.57c0,3-5.34,5.35-11.92,5.35s-11.92-2.39-11.92-5.35Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-49"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 435.18,
    rx: 211.97,
    ry: 22.61,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.4 382.79 87.55 382.55 141.7 382.46 250 382.3 358.3 382.46 412.45 382.55 466.6 382.79 412.45 383.04 358.3 383.13 250 383.29 141.7 383.13 87.55 383.04 33.4 382.79",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 58.49,
    width: 156.87,
    height: 110.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 47.97,
    width: 156.87,
    height: 10.52,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.05,99.85A9.7,9.7,0,0,0,232.56,94c-2.59-1.55-13.48-2.7-16.16-.47s-3.44,10.55-.57,13.29,8,2.92,8,2.92l-.28,2.4s-6.72-.23-10.1-3-4.18-13.57.3-17.9,15.45-3.4,18.85-2.27,10.08,4.79,11.85,5S239.55,99.67,237.05,99.85Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,109.39c1.65,0,3.87-.86,5.85-.76s5.32,1.51,5.42,2.83-3.4,3.11-5.64,3-4.07-2.22-5.63-2.48c0,0,1.09-.39,1.28-1S221.2,109.39,221.2,109.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,114c-1.93,3.43-7,5.65-7.33,9.57-.35,3.7-.48,14.15-2.34,16.15a5.16,5.16,0,0,1-8.43,0c-1.86-2-2-12.45-2.33-16.15-.38-3.92-5.41-6.14-7.34-9.57-1-1.86-2.5-9.31-.28-13.53s8-7.51,14.17-7.51,11.95,3.29,14.17,7.51S265.81,112.1,264.77,114Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,113.92v11.33c0,1.93,2.95,3.69,2.95,5s-.78,7.69-2.13,10.75a4.16,4.16,0,0,1-5,0c-1.35-3.06-2.14-9.53-2.14-10.75s2.95-3.11,2.95-5V113.92c0-2.47-6.76-5.53-6.76-7.78s4.13-5.64,8.43-5.64,8.43,3.39,8.43,5.64S252.55,111.45,252.55,113.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.73,99.85A9.7,9.7,0,0,1,269.22,94c2.58-1.55,13.47-2.7,16.16-.47s3.44,10.55.57,13.29-8,2.92-8,2.92l.29,2.4s6.72-.23,10.1-3,4.18-13.57-.3-17.9-15.46-3.4-18.85-2.27-10.08,4.79-11.85,5S262.23,99.67,264.73,99.85Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58,109.39c-1.66,0-3.87-.86-5.85-.76s-5.32,1.51-5.42,2.83,3.4,3.11,5.63,3,4.07-2.22,5.64-2.48c0,0-1.09-.39-1.28-1S280.58,109.39,280.58,109.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,109.39c1.65,0,3.87-.86,5.85-.76s5.32,1.51,5.42,2.83-3.4,3.11-5.64,3-4.07-2.22-5.63-2.48c0,0,1.09-.39,1.28-1S221.2,109.39,221.2,109.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,109.39c1.65,0,3.87-.86,5.85-.76s5.32,1.51,5.42,2.83-3.4,3.11-5.64,3-4.07-2.22-5.63-2.48c0,0,1.09-.39,1.28-1S221.2,109.39,221.2,109.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58,109.39c-1.66,0-3.87-.86-5.85-.76s-5.32,1.51-5.42,2.83,3.4,3.11,5.63,3,4.07-2.22,5.64-2.48c0,0-1.09-.39-1.28-1S280.58,109.39,280.58,109.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,95.93c-.55-1.7-1-3.42-1.52-5.13s-.92-3.45-1.36-5.17-.84-3.46-1.21-5.21L243,77.81c-.17-.88-.35-1.75-.49-2.64.28.85.53,1.71.79,2.56L244,80.3c.49,1.72.92,3.44,1.36,5.17s.84,3.46,1.21,5.21S247.3,94.16,247.59,95.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.71,111.53c-2.87-1.68-5.69-3.42-8.51-5.16s-5.61-3.54-8.41-5.31-5.57-3.59-8.34-5.43l-4.13-2.76c-1.37-.93-2.75-1.86-4.1-2.81,1.43.83,2.84,1.7,4.27,2.55l4.23,2.61c2.82,1.74,5.61,3.53,8.41,5.3s5.57,3.6,8.34,5.43S225,109.63,227.71,111.53Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.52,94.21c1.35-.64,2.73-1.21,4.1-1.77s2.77-1.08,4.16-1.6,2.8-1,4.21-1.47l2.13-.68c.71-.2,1.42-.43,2.15-.62-.68.33-1.36.61-2,.92l-2.06.85c-1.38.57-2.77,1.09-4.16,1.6s-2.8,1-4.22,1.47S290,93.82,288.52,94.21Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,135.14c1.51,1.62,3,3.28,4.41,5s2.87,3.36,4.28,5.06,2.8,3.42,4.16,5.17l2,2.61c.67.89,1.34,1.76,2,2.66-.76-.81-1.49-1.64-2.23-2.46l-2.18-2.5c-1.45-1.67-2.87-3.37-4.28-5.07s-2.8-3.42-4.16-5.16S252.19,136.93,250.89,135.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.9,
    y: 84.62,
    width: 13.17,
    height: 4.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.85,
    y: 69.31,
    width: 13.17,
    height: 4.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.93,
    y: 84.62,
    width: 13.17,
    height: 4.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.31,
    y: 154.6,
    width: 13.17,
    height: 4.87,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.28,297.28c7.18-14.75,19.74-22.32,33.9-18.14s16.34,23.93,5.78,28.91-21.13-9.57-26.72-12.56S423.28,297.28,423.28,297.28Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.34,336.55c0-1.77.1-3.55.17-5.33q.18-5.33.37-10.65c.24-6.49.94-12.87,3.63-18.86a29.29,29.29,0,0,1,11.39-13.12,24.31,24.31,0,0,1,6-2.58,14,14,0,0,1,7-3.84,28.72,28.72,0,0,1,10-.25c.11,0,.11.2,0,.19a24.16,24.16,0,0,0-9.42.67,19.61,19.61,0,0,0-3.79,1.48,18.2,18.2,0,0,0-2.2,1.39,20.36,20.36,0,0,1,8.65.08,19.52,19.52,0,0,1,3,1,9.46,9.46,0,0,1,2.36-.2,14.48,14.48,0,0,1,3.07.44,23,23,0,0,1,5.82,2.54.09.09,0,0,1-.1.16,21.79,21.79,0,0,0-5.68-2.14,19.4,19.4,0,0,0-2.92-.43,14.74,14.74,0,0,0-1.63,0,18.7,18.7,0,0,1,9.15,9.12c.05.11-.11.2-.16.09A17.18,17.18,0,0,0,449.31,287c-.32-.08-.63-.12-.95-.19.11.46.09,1,.15,1.43.1.72.22,1.43.36,2.14a37.64,37.64,0,0,0,1.15,4.32,33.83,33.83,0,0,0,1.72,4.19,20.27,20.27,0,0,0,2.39,4c.09.1-.08.22-.15.11-.85-1.33-1.84-2.56-2.62-3.95a29.48,29.48,0,0,1-1.91-4.11,28.68,28.68,0,0,1-1.27-4.43c-.15-.79-.28-1.59-.37-2.4a6,6,0,0,1-.09-1.46,19.18,19.18,0,0,0-5-.1c.62,3.52,1.3,7.18,3.27,10.24.07.1-.11.2-.16.09a43.17,43.17,0,0,1-2.44-5,19.28,19.28,0,0,1-1.21-5.25,23.15,23.15,0,0,0-8.31,2.79,27.41,27.41,0,0,0-11.06,12.11,45.33,45.33,0,0,0-4.1,17.34c-.48,7.54-.57,15.13-1.33,22.65-.05.49-.82.66-.92.1A26.61,26.61,0,0,1,416.34,336.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.92,287.41a8.13,8.13,0,0,1,1.64-1.51c.58-.48,1.19-.95,1.82-1.38a13.31,13.31,0,0,1,4.08-1.89c.11,0,.16.15,0,.18a10.66,10.66,0,0,0-4,2c-.6.44-1.18.91-1.74,1.4a10.45,10.45,0,0,1-1.65,1.4C433,287.64,432.85,287.52,432.92,287.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.83,292.76a43.53,43.53,0,0,1,3.29,4.35,26.67,26.67,0,0,1,2.45,4.86s-.06.07-.09,0a57.94,57.94,0,0,0-5.78-9.11C455.62,292.79,455.75,292.66,455.83,292.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,291.3a10.43,10.43,0,0,0,.81,2.67,17.89,17.89,0,0,0,1.37,2.36c0,.05-.05.1-.09.06a9.64,9.64,0,0,1-2.27-5.05C440.19,291.22,440.37,291.18,440.39,291.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.34,297.65s-10.16-12.77-29.78-8.25c-18.64,4.31-27.25,38.49-8.41,42.58s15.52-27.54,22.39-32.91C406.57,295.13,413.82,296,417.34,297.65Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.41,308.07a38.89,38.89,0,0,1,4-3.09,17.94,17.94,0,0,1,4.31-2.16,26,26,0,0,1,2.56-3.28,25.06,25.06,0,0,1,5.93-4.72,5.85,5.85,0,0,0-.59,0,29.55,29.55,0,0,0-3.12,0,17.42,17.42,0,0,0-6.05,1.5.09.09,0,0,1-.08-.17,27.6,27.6,0,0,1,6-1.82,17.4,17.4,0,0,1,3.06-.26c.55,0,1.1,0,1.65.1l.31,0a26.11,26.11,0,0,1,5.66-2.08l-.55-.15a25.93,25.93,0,0,0-2.91-.47,22.19,22.19,0,0,0-5.87.09.1.1,0,0,1,0-.19,37.91,37.91,0,0,1,5.93-.24,26,26,0,0,1,4.94.64,26.35,26.35,0,0,1,3.57-.41c6.84-.29,14.3,2.27,18.51,7.89s5,13.13,5.78,19.92a151.79,151.79,0,0,1,.75,28.51c-.05.56-.84.46-.85-.07-.26-8.06-.54-16.13-1.32-24.16-.35-3.72-.75-7.45-1.37-11.14a32.93,32.93,0,0,0-2.7-9.17A16.79,16.79,0,0,0,413.4,296a22.33,22.33,0,0,0-9.38-2.88,25.29,25.29,0,0,0-8.8.82,5.64,5.64,0,0,1,0,1.74,9.67,9.67,0,0,1-.43,2.14,10.68,10.68,0,0,1-.82,1.9c-.36.68-.82,1.28-1.22,1.92-.07.11-.23,0-.16-.11a8.78,8.78,0,0,0,1.52-3.86,15,15,0,0,0,.24-2c0-.51,0-1,0-1.52a26,26,0,0,0-8.56,4.52c-.48.38-.94.79-1.39,1.2a9.5,9.5,0,0,1,1.67,2.05,19.23,19.23,0,0,1,1.74,3.1,26.42,26.42,0,0,1,1.82,6.83.1.1,0,0,1-.19,0,19.9,19.9,0,0,0-2.23-6.47,28.1,28.1,0,0,0-1.74-2.87c-.33-.47-.67-.94-1-1.39-.19-.24-.4-.49-.58-.75a27.2,27.2,0,0,0-5.57,7.83l0,0a13.3,13.3,0,0,1,2.3,3.3,32.71,32.71,0,0,1,1.84,3.93,66.69,66.69,0,0,1,2.34,8c0,.11-.17.15-.19,0a33.59,33.59,0,0,0-2.78-7.88c-.59-1.23-1.2-2.44-1.86-3.63a35.36,35.36,0,0,1-1.84-3.43,25.36,25.36,0,0,0-2.24,9.08.09.09,0,1,1-.18,0,31.67,31.67,0,0,1,4.4-13.94c-1.2.51-2.4,1-3.56,1.62a19.63,19.63,0,0,0-4.08,2.87C372.44,308.3,372.32,308.15,372.41,308.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8,308.8c.59,1.93,1.33,3.81,1.86,5.77a22.07,22.07,0,0,1,.86,5.77c0,.05-.08.05-.09,0a56.71,56.71,0,0,0-2.81-11.49C386.57,308.73,386.76,308.67,386.8,308.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.37,304a11.08,11.08,0,0,1,2.6-1.85,18.9,18.9,0,0,1,3-1.07c.11,0,.15.16,0,.19a11.74,11.74,0,0,0-2.89,1.19,21.47,21.47,0,0,0-2.67,1.64A.06.06,0,0,1,374.37,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,280.59s-1.88-22.95-18.93-30.38C374.5,244,366.35,260,376.42,269.8,384.56,277.73,397.63,274.15,407.68,280.59Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,254.65a74,74,0,0,1,7.59,3.59,58.94,58.94,0,0,1,5.89,3.91c-.29-.58-.53-1.18-.82-1.75-.44-.89-.92-1.75-1.45-2.6a24.6,24.6,0,0,0-3.75-4.75c-.09-.08.05-.22.13-.13a37.68,37.68,0,0,1,4,4.6,29,29,0,0,1,1.62,2.6,10.29,10.29,0,0,1,1.14,2.64l.19.14a55.84,55.84,0,0,1,8.15,8l-.15-.66c-.32-1.12-.67-2.23-1-3.33a28.38,28.38,0,0,0-3.08-6.69c-.07-.1.1-.2.16-.09a52.23,52.23,0,0,1,3.58,6.52,24.25,24.25,0,0,1,1.17,3.39,14.45,14.45,0,0,1,.56,2.31c.74.94,1.47,1.89,2.16,2.87,7.32,10.43,11,23,11.88,35.65a106.72,106.72,0,0,1,.19,11.31,69.47,69.47,0,0,1-1,11.34c0,.24-.42.17-.41-.06.09-3.32.43-6.62.49-9.94a97.38,97.38,0,0,0-.32-10A92,92,0,0,0,412.69,294,70.11,70.11,0,0,0,404,275.65c-.72-.14-1.43-.34-2.14-.52l-2.55-.67a25.86,25.86,0,0,1-4.76-1.75c-.1,0,0-.22.1-.16a15.51,15.51,0,0,0,4.82,1.67c1.34.26,2.73.44,4.06.74a62.65,62.65,0,0,0-4-5.21,29.66,29.66,0,0,1-9.71-.73,39.64,39.64,0,0,1-5-1.54c-1.71-.66-3.32-1.51-5-2.21-.12,0,0-.24.08-.17a28.35,28.35,0,0,0,9.84,3.22,60.31,60.31,0,0,0,9.2.76c-1.21-1.39-2.46-2.75-3.8-4-4.48-4.26-9.8-8.19-15.7-10.23C379.4,254.79,379.46,254.6,379.57,254.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.45,254.72a25.43,25.43,0,0,1,2.09,3.06,16.42,16.42,0,0,1,1.51,3.56s-.05.06-.07,0c-.57-1.13-1.05-2.3-1.63-3.42a17.24,17.24,0,0,0-2-3.1C393.24,254.76,393.38,254.63,393.45,254.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.59,262.36a17.61,17.61,0,0,0,3.5,1.46,31.15,31.15,0,0,0,3.56,1c.06,0,0,.1,0,.1a17.16,17.16,0,0,1-3.68-.81,31.49,31.49,0,0,1-3.46-1.55C377.39,262.47,377.48,262.3,377.59,262.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,276.46c.11,1,2.58-8.33,17-16.61,13.1-7.51,28.74-27.06,15.89-39.41C443.47,210.47,416.16,232.2,420.94,276.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,329.9a256,256,0,0,1,2.29-29,130.62,130.62,0,0,1,6.09-26c1.08-3,2.3-6,3.63-8.95a21.74,21.74,0,0,1,.06-3.43c.07-1.47.21-2.94.34-4.4s.29-2.93.46-4.39.48-2.92.55-4.38c0-.13.21-.1.18,0a31.51,31.51,0,0,0-.52,4.65c-.11,1.41-.19,2.83-.23,4.25s0,2.83,0,4.25c0,.52,0,1.06.05,1.61q2-4.31,4.38-8.44c-1-6,.29-12.23,1.51-18.08,0-.12.21-.06.18.06A51.39,51.39,0,0,0,429,247c-.05,2.46.06,4.92.07,7.37.35-.59.69-1.18,1.05-1.76,1.87-3.05,3.86-6.05,6-9a13.83,13.83,0,0,1,.14-4.26,33.72,33.72,0,0,1,1-4.66c.46-1.53,1-3,1.6-4.5s1.46-2.95,2.06-4.47c.05-.13.24,0,.17.07a22.2,22.2,0,0,0-1.81,4.53,43.41,43.41,0,0,0-1.18,4.48c-.3,1.52-.55,3-.77,4.58-.14,1-.23,2.07-.4,3.09a109.92,109.92,0,0,1,10.1-11.75c.09-.09.21,0,.13.13a133.18,133.18,0,0,0-14.67,20c-.15.27-.3.54-.46.81.79-.5,1.71-.9,2.45-1.31q2.1-1.17,4.21-2.31t4.09-2.24c.7-.39,1.39-.79,2.1-1.16a16.6,16.6,0,0,0,2.44-1.35c.11-.08.23.09.11.15-1.39.76-2.61,1.9-3.95,2.75s-2.72,1.69-4.12,2.47c-2.57,1.43-5.35,2.46-7.88,3.94-1.75,3.06-3.36,6.21-4.85,9.41,1.53-1,3.1-1.91,4.69-2.8,1-.57,2-1.14,3.08-1.68a15.26,15.26,0,0,0,2.9-1.76.1.1,0,1,1,.13.14,27.3,27.3,0,0,1-5.54,3.85c-1.85,1.09-3.72,2.13-5.65,3.08-1.54,3.37-2.94,6.82-4.17,10.32-6.08,17.19-8.31,35.44-9.37,53.56-.32,5.4-.48,10.8-.55,16.22s.22,10.8.21,16.2c0,.16-.27.2-.29,0-.65-4.79-.76-9.66-1-14.49S410.9,334.82,411,329.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.22,252.08a69.35,69.35,0,0,0,7.66-4,82.07,82.07,0,0,0,7.28-4.62s.09,0,0,.06a61.25,61.25,0,0,1-7,4.89,70.9,70.9,0,0,1-7.91,3.8C437.2,252.29,437.11,252.13,437.22,252.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,232.65c.21-.84.48-1.66.76-2.48a.09.09,0,0,1,0-.1c.18-.46.38-.92.57-1.38a1.07,1.07,0,0,1,.06-.17c0-.09.08-.18.11-.27s.06,0,.05,0-.09.32-.14.48a2.58,2.58,0,0,1-.08.26,69.58,69.58,0,0,0-2.14,9.8.09.09,0,0,1-.17,0A32.91,32.91,0,0,1,433,232.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.77 333.39 396.8 345.59 399.95 382.8 433.7 382.8 436.85 345.59 437.88 333.39 395.77 333.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.77 333.39 396.8 345.59 436.85 345.59 437.88 333.39 395.77 333.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.46,
    y: 328.49,
    width: 48.73,
    height: 11.7,
    transform: "translate(833.65 668.69) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.66,437.24c2.33.76,69.09.14,71.61-1.5,1-.6,1.45-10.34,1.69-22.11v-.37c.06-2.43.1-4.93.11-7.46,0-.35-3.05-35.68-3.05-35.68l-43.64.29,3.27,35.67.24,7.1,0,.73s-25.44,11.67-28,13.76S291.32,436.49,293.66,437.24Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,419.74c-.28,8.87-.74,15.51-1.54,16-2.52,1.63-69.28,2.26-71.62,1.49s-.34-7.48,2.23-9.56c1-.81,5.4-3,10.43-5.48-2.62,2.84-3.94,6,3.07,6C321.84,428.18,343.58,426.13,366.81,419.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,412.57h48.08s-9.68-112.28-9.3-114.24c.48-2.51,3.32-13.88,7.09-28.73,1.19-4.64,2.46-9.63,3.79-14.79,3.59-14,7.54-29.24,11-42.52,5.17-19.91,9.2-35.37,9.2-35.37H350.87s-4.75,15.06-10.74,34.64c-9.75,31.83-22.78,75.64-24.06,86.29C314,315,321.77,412.57,321.77,412.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9,404.37c7.35-.15,5.24-.21,12.58-.28,3.59,0,27.21-.24,30.56.31a.08.08,0,0,1,0,.15c-3.35.56-27,.35-30.56.32-7.34-.07-5.23-.13-12.58-.28C323.77,404.58,323.77,404.37,323.9,404.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,291.47c1.58-7,3.93-13.76,6-20.59q6.25-20.79,12.58-41.55,3.15-10.4,6.34-20.77c1.08-3.49,2.15-7,3.24-10.47s2.29-6.8,3.26-10.24c.39-1.4.6-.63.1,1.15-1,3.58-2,7.17-3.06,10.75q-3.1,10.62-6.25,21.24-6.26,21.13-12.61,42.22-3.18,10.59-6.37,21.16a88.08,88.08,0,0,0-2.6,10.23,47.22,47.22,0,0,0-.42,10.95c.46,7.36,1.31,14.7,2,22l2,22.06q2,22,4,43.91.25,2.78.47,5.57c0,.62-.39.69-.45.09-1.59-14.47-3.3-29.11-4.66-43.6s-2.71-28.84-4.05-43.27c-.34-3.62-.73-7.25-.73-10.89A44.85,44.85,0,0,1,351.5,291.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,176.92c2.83,21.89,8.22,62.92,12.15,92.68,9.19-36.06,24-92.68,24-92.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.48,437.24c2.34.76,69.1.14,71.62-1.5,1-.6,1.45-10.34,1.69-22.11v-.37c.06-2.43.1-4.93.11-7.46,0-.35,0-.7,0-1.05.15-17-1.07-34.63-1.07-34.63l-43.64.29,1.22,34.31.05,1.36.24,7.1,0,.73s-25.44,11.67-28,13.76S343.14,436.49,345.48,437.24Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.64,419.74c-.28,8.87-.74,15.51-1.54,16-2.52,1.63-69.28,2.26-71.62,1.49s-.34-7.48,2.23-9.56c1-.81,5.4-3,10.43-5.48-2.62,2.84-3.94,6,3.07,6C373.67,428.18,395.41,426.13,418.64,419.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.18,176.92s.94,19.5,5.41,34.94c.35,1.27.74,2.53,1.16,3.73a72.56,72.56,0,0,1,11.74,6s.47,15.68.94,33.18c.52,19.55,1.06,41.36.95,46-.41,17.31,2.17,112.48,2.17,112.48l48.06.19S413.92,307.19,414,300.85c.1-10.19-2.32-55.23-4.19-88.08a261.19,261.19,0,0,0-4.49-35.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.19,404.73c7.35-.12,5.24-.19,12.58-.23,3.59,0,27.21-.13,30.56.44a.08.08,0,0,1,0,.15c-3.36.55-27,.24-30.56.19-7.35-.1-5.24-.15-12.58-.34A.11.11,0,0,1,376.19,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,183.89c.89,26.82,1.83,53.63,3,80.44s7.51,123.17,9.13,138.12c0,.1-.14.14-.15,0-3.5-26.6-5.45-66-7.18-92.74s-2.88-53.58-3.8-80.39c-.51-15.16-.91-30.32-1.36-45.49C403.32,183.66,403.66,183.68,403.66,183.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.75,214.43a88.94,88.94,0,0,1,13.74,7.2.16.16,0,0,1-.14.28c-4.64-2.25-9.37-4.42-13.88-6.92A.31.31,0,0,1,356.75,214.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,197.89c.32,1.71.73,3.4,1.1,5.1s.6,3.22,1,4.8a8.14,8.14,0,0,0,2.24,4c.62.58,1.31,1.1,2,1.63.36.29.75.56,1.12.85-.05-.22-.09-.45-.13-.68l-.33-1.95q-.36-2.16-.69-4.32c-.44-2.83-.84-5.7-1.43-8.51a.09.09,0,0,1,.18,0c.7,2.78,1.48,5.53,2.1,8.34.3,1.37,1.38,8.16,1.43,8.64s.09,1,.1,1.5a5.53,5.53,0,0,1,0,1.52c0,.13-.17.11-.23,0h0a6.31,6.31,0,0,1-.44-1.48c-.12-.48-.23-1-.32-1.47,0-.18-.05-.36-.08-.54-.67-.41-1.29-.94-1.91-1.4s-1.37-1-2-1.5a7.6,7.6,0,0,1-2.44-3.81,27.76,27.76,0,0,1-.8-4.88c-.22-1.93-.38-3.87-.64-5.79C356.29,197.82,356.46,197.78,356.48,197.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.12,72.1c7.09,4.84,10.63,14.33,10.63,14.33s7.58,8.81,7,14.46a10,10,0,0,1-5,7.76v-3.07s-1.21,4.17-7.36,6.9-15,2.33-19.86.91a17.36,17.36,0,0,1-7.57-4.51l2.46,4a13,13,0,0,1-11.22-5c-4.94-6,3.94-17.48,4.46-19.7s-1.12-17.42,15.13-17.76C371.78,70.41,378.23,68.76,383.12,72.1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.93,107.84a10.22,10.22,0,0,0,3.36-5.14,9.35,9.35,0,0,0-.1-6.09,20.9,20.9,0,0,0-4.2-6.1c-1.68-1.91-3.51-3.71-5.16-5.66-.09-.11.07-.24.17-.16a56.72,56.72,0,0,1,4.87,4.43A27,27,0,0,1,401,93.84a10.09,10.09,0,0,1,1.75,5.38,9.73,9.73,0,0,1-1.2,4.51A21,21,0,0,1,398,108C398,108,397.84,107.91,397.93,107.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.59,101.28c.87-5.87,5.18-10.29,7.3-15.66,1.15-2.9,1.88-6,3.59-8.68,0-.07.17,0,.12.08-1.36,2.36-1.92,5-2.75,7.56A40.74,40.74,0,0,1,354.37,92c-2.43,4.32-5.35,9.45-3.65,14.56.78,2.36,2.7,4.77,5.32,5.07a.08.08,0,1,1,0,.15,7.85,7.85,0,0,1-5.13-3.54A10.08,10.08,0,0,1,349.59,101.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.64,102.81a10.31,10.31,0,0,1,.27-6.24,14.76,14.76,0,0,1,3.72-5c1.73-1.68,3.58-3.31,4.44-5.62,0-.1.18,0,.15.07-1.35,3.79-4.83,6.1-6.85,9.45-2.31,3.84-1.42,8.65,1.29,12a16.93,16.93,0,0,0,6.32,4.75s0,.08,0,.06C354.77,110.53,350.8,107.39,349.64,102.81Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,132.84c-4.56,11.31-22.66,47.86-34.54,50.44C326,185,294.44,181.92,289,174.46c-2.36-3.25,1.64-25.9,5.84-25s29.48,4.24,32.58,3.33,26.37-27.68,35.06-34.33C377.47,107,370.76,126.75,368.31,132.84Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,147.82l-.67,34.05s25,4.56,35.66.43c13-5,30.73-46.38,33.12-53.16,3.93-11.13,2.49-17.74-3.57-15.89-2.36.7-5.42,2.68-9.13,6.2-3.89,3.66-26.11,27.32-33.23,31.9C322.59,153.91,304.39,147.82,304.39,147.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.05,180.43c.25-5,.52-25.64.27-30.1,0-.31-.21-.37-.24-.05-1.11,15.05-.24,25.19-.23,30.13C309.85,180.54,310,180.56,310.05,180.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3,183.33c8.12.85,19,1.34,25.09-1,13-5,30.72-46.38,33.11-53.16,3.93-11.13,2.49-17.73-3.57-15.89-.19,0-.38.12-.57.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.33,161.46l-4.76,32.68s53.26.79,66.49-.14c0,0-10.79-61.1-25-76.54-7.12-7.72-15.46-7.14-20.78-1.74-1.35,1.36-17.42,22.6-19.11,30.71C344.7,153.58,349.33,161.46,349.33,161.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.16,112.94s-4.62,175.5-.22,183.05c2.68,4.6,47.05-6.42,47.05-6.42s-11.47-104-24.64-141C390.13,114.25,380.16,112.94,380.16,112.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.24,217.69a114.73,114.73,0,0,1-13.55,1.06c-6.34,0-12.64-.62-14.45-.65-.17,0-.25.54-.14.55a142.77,142.77,0,0,0,14.47,1,75.92,75.92,0,0,0,13.2-1.25c0,1.34,0,2.39,0,3.73-4.47.87-13.1,2.36-27,.57-.05-.56,0-3.55-.09-4.37,0-.13-.53-.15-.56,0-.11.81-.44,8-.45,9.45,0,3.6.22,13.77,1.11,15.74,2,4.46,10.71,4.47,13.12,4.49s10.15.26,13-2.58c1.55-1.51,1.89-9.75,1.66-17C413.45,225,413.45,217.75,413.24,217.69Zm-13.7,29.47c-7.68,0-11-1.6-12.2-3.2-1.38-1.87-1.5-5.12-1.6-8.71-.08-2.82,0-11.66,0-11.84,4.48.91,16.28,2.14,27-.36,0,4.19,0,7.54,0,11.73,0,3-.19,8.12-1.72,9.89C409.77,246.15,405.09,247.16,399.54,247.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.36,292.71c-2.57,1.26-27.52-13.46-27.52-13.46L349,160.86a21.22,21.22,0,0,1-2.88-14.3c1.38-8,18.08-31.1,20.77-32.29a258.72,258.72,0,0,0-5.79,36.26C356.51,200.49,347.91,291.44,345.36,292.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.42,135.77c1.48-2.37,3-4.72,4.47-7.1,0-.07-.06-.15-.11-.09q-2.23,2.94-4.39,5.93c.48-1.06.94-2.14,1.37-3.22.05-.13-.12-.23-.18-.1-.66,1.4-1.26,2.82-1.85,4.25a40.68,40.68,0,0,0-3.4,5.63,19.59,19.59,0,0,0-1.8,13.29,16.78,16.78,0,0,0,1.32,3.63c.4.79,1.68,2.5,1.67,2.55-.83,4.66-1.46,9.37-2.12,14.06s-.57,10.73-.19,8.39c.75-4.72,1.43-9.45,2.11-14.18.39-2.68.81-5.36,1.12-8a24.78,24.78,0,0,0-1.54-2.94,18.43,18.43,0,0,1-1.17-3.08,17.15,17.15,0,0,1-.56-6.61C346.69,143.6,349,139.56,351.42,135.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,114.79c-1.57,2.38-3.16,4.73-4.78,7.07s-3.23,4.69-4.89,7l0-.55,4,4.18.33.35-.35.34c-1.68,1.63-3.39,3.22-5.1,4.83l.15-.42c.61,4.33,1.28,8.66,1.83,13s1.13,8.68,1.61,13c-.82-4.3-1.58-8.62-2.3-12.93s-1.4-8.65-2.09-13l0-.24.18-.18c1.68-1.62,3.37-3.24,5.08-4.84l0,.69-3.92-4.26-.24-.26.21-.29c1.67-2.29,3.42-4.54,5.13-6.81S365,117,366.81,114.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,123.43c21,19.66,45.61,53.73,36.91,62.08-5.77,5.55-34.74-31.49-34.23-31.39,1.09.2-5.19-12.11-12.89-27C375.81,110.47,382.63,112.19,394.61,123.43Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,114.85c14.59,7.23,54.74,54,49.49,68.43s-38.4-28.95-38.06-29.58-8.08-17.09-11.5-23.79S376.62,111,384.39,114.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.37,137.73c.81.85,1.6,1.71,2.36,2.6.14.16.27.34.4.5-.22-.47-.45-.94-.68-1.41a50.87,50.87,0,0,1-2.34-5c0-.08.09-.13.14-.06a53,53,0,0,1,2.83,5c.89,1.65,1.8,3.3,2.66,5s1.74,3.34,2.57,5a39,39,0,0,1,2.27,5.08c0,.1-.11.15-.17.07a39.42,39.42,0,0,1-2.9-5c-.88-1.67-1.72-3.35-2.57-5-.36-.7-.71-1.41-1.05-2.12l-.41-.46c-.38-.43-.74-.87-1.09-1.32-.72-.92-1.4-1.87-2.07-2.83C386.3,137.74,386.35,137.7,386.37,137.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,114.94q1.63,3.84,3.36,7.62c1.15,2.52,2.27,5.06,3.46,7.56l.11-.54-4.23,3.62-.35.3.27.38c1.3,1.83,2.64,3.63,4,5.44l-.07-.43c-1.17,4.21-2.39,8.41-3.5,12.64S381,160,379.94,164.22c1.36-4.15,2.65-8.32,3.92-12.5s2.49-8.38,3.73-12.57l.07-.23-.14-.2c-1.31-1.82-2.61-3.65-3.95-5.45l-.07.68,4.16-3.7.26-.23-.15-.31c-1.2-2.49-2.47-4.94-3.71-7.42S381.54,117.38,380.24,114.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,119c.34-5.23-3.93-7.09-7.85-7.62-4.65-.63-7.74-.24-10,4.27-2.35,4.75-3.57,10.26-4.49,15.46a.76.76,0,0,1-1.51-.24c1.05-6,2.56-17.17,8.52-20.43,5.49-3,17.39-.06,16.8,8.81-.07,1-1.58.73-1.51-.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.41,133.27a3.52,3.52,0,1,0,4-2.92A3.53,3.53,0,0,0,355.41,133.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8,133.49a2.12,2.12,0,1,0,2.42-1.76A2.11,2.11,0,0,0,356.8,133.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,135.38c-3.84,14.72-3.24,18.31-2,20a9.82,9.82,0,0,0,3.45,2.78l.45-1-.22.48.22-.48a8.79,8.79,0,0,1-3-2.44c-.88-1.22-1.62-4.53,2.19-19.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.8,
    y: 155.9,
    width: 2.28,
    height: 3.7,
    rx: 1.11,
    transform: "translate(57.9 413.51) rotate(-61.14)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,135.73c2.93,11.08,3.65,17.15,2.25,19.09a8.75,8.75,0,0,1-3,2.45l.45,1a9.74,9.74,0,0,0,3.44-2.79c1.67-2.32,1.07-8.11-2.08-20Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,156h0a1.11,1.11,0,0,1,1.11,1.11v1.47a1.12,1.12,0,0,1-1.12,1.12h0a1.11,1.11,0,0,1-1.11-1.11V157.1A1.11,1.11,0,0,1,386,156Z",
    transform: "translate(435.54 571.88) rotate(-119.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1,135a58.35,58.35,0,0,0-1.92-7.25,6.36,6.36,0,0,0-2.14-2.62c-.21,0-.12-1.89,0-3.41.1-1.35.24-2.91-.09-3.35a1.06,1.06,0,0,0-1.46-.07c-.37.4-.39,2-.43,3.32-.05,1.53-.15,3.39-.36,3.39a7.06,7.06,0,0,0-2.28,2.43,49.67,49.67,0,0,0-2.53,7.24c-.34,1.58.18,1.77.63,1.92.64.22,1-.22,1.54-2,.79-2.77,1.79-7.42,3.71-7.41h0c1.91.19,2.69,5.11,3.31,7.86.39,1.72.75,1.88,1.41,1.73C387.93,136.72,388.41,136.52,388.1,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.94,136.81s3.7-5.54-.29-7.76-6.74,3.86-6.74,3.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.26,173.64h0l-.17,6.52-.07,2.16,1.81-1.18,5.46-3.59h0l22.78-41-7-3.91-22.78,41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.09 180.17 340.03 182.32 341.84 181.14 340.09 180.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.53,
    y: 134.29,
    width: 9.39,
    height: 1.86,
    transform: "translate(620.58 431.38) rotate(-150.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.53,
    y: 136.09,
    width: 9.39,
    height: 1.86,
    transform: "translate(617.82 434.28) rotate(-150.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.87 140.12 366.23 138.65 359.44 154.28 360.45 154.77 368.87 140.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.52,185.51c-7.89,7.68-39.37,3.56-59.44-2.45-3.82-1.15,8.52-35.12,12.45-33.48a110,110,0,0,0,12.76,4.54C398.38,154.32,440.17,177.11,431.52,185.51Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.07,151c.3,3.81,9.62,2.3,9.62,2.3a7,7,0,0,0-2.54,4.06c-.48,2.86,3.8,4.86,3.8,4.86a8.72,8.72,0,0,0-2,4.71c-.18,2.79,3.85,5.43,3.85,5.43a7.64,7.64,0,0,0,.85,5.25c2.58,4.15,10.09,3.63,14.81,4.23A99,99,0,0,1,381,185.43l5.82-34.89s-21.07-10.29-26.67-9.56C355.48,141.59,336.63,145.18,337.07,151Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.76,153.18c4.86-1.85,10.14-2.54,15.26-3.15a.09.09,0,0,1,0,.18c-5.09.55-10.15,2.46-15.21,3.21A.13.13,0,0,1,346.76,153.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.05,161.83a13.4,13.4,0,0,1,3.51-.49c1.25-.08,2.51-.15,3.76-.19,2.51-.09,5-.12,7.54-.08.11,0,.14.17,0,.18-2.5.09-5,.22-7.5.42l-3.75.33a16.17,16.17,0,0,1-3.54.17A.18.18,0,0,1,348.05,161.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.9,172.35a9.4,9.4,0,0,1,3.18-.26l3.43-.07c2.29-.06,4.58-.12,6.87-.26.11,0,.13.17,0,.18-2.32.15-4.64.33-7,.47l-3.42.17a8.83,8.83,0,0,1-3.12-.11C349.84,172.45,349.85,172.37,349.9,172.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.88,183.28c-5.25,14.4-51.17,3.35-51.17,3.35l.46-37.79s12.31,5.49,12.65,4.86S439.13,168.89,433.88,183.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.39,184.9c.33-5,.9-25.39.72-29.81,0-.31-.21-.37-.24-.05-1.32,14.89-.61,24.94-.67,29.84C389.2,185,389.39,185,389.39,184.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,148.84a28.6,28.6,0,0,1,3.93,1.38c1.15.45,2.3.9,3.44,1.37,2.49,1,5,2.08,7.41,3.17s4.9,2.19,7.32,3.34,4.78,2.44,7.2,3.59c.11.05,0,.21-.09.16-2.46-1.11-5-2-7.47-3.1l-7.29-3.08-7.3-3.07c-1.19-.5-2.37-1-3.56-1.53a30.09,30.09,0,0,1-3.78-1.74A.27.27,0,0,1,383.44,148.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.55,185.82c0-.25.13-.32.19,0s.08.41.12.55c1.56.27,7.25,1.45,8.64,1.72,2.92.58,5.8,1.29,8.75,1.66a113.94,113.94,0,0,0,12.35.89.09.09,0,1,1,0,.18,108.58,108.58,0,0,1-12.39-.34c-3-.35-6-.83-8.94-1.44-1.48-.3-2.95-.65-4.42-1a22.06,22.06,0,0,1-4.15-1.25.31.31,0,0,1-.16-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.46 185.35 349.05 186.19 331.65 135.01 292.06 134.17 309.46 185.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.75 185.29 346.33 186.13 328.94 134.96 289.35 134.11 306.75 185.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,134.87a3.5,3.5,0,0,0,1.65,2.1c.38.21.49-.28.12-.48a2.55,2.55,0,0,1-1.12-1.32c0-.1-.07-.2-.09-.29a1.9,1.9,0,0,1,0-1,.67.67,0,0,1,.23-.34l0,0,.05,0h.07a.45.45,0,0,1,.28,0,1.15,1.15,0,0,1,.45.3,2.2,2.2,0,0,1,.38.54,2.75,2.75,0,0,1,.17.29l0,.07a.47.47,0,0,1,.05.1.19.19,0,0,1,0,.07h.56a4.05,4.05,0,0,0-.51-1,2.19,2.19,0,0,0-1.5-1,.87.87,0,0,0-.9.79A2.25,2.25,0,0,0,324.73,134.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,134.8a3.52,3.52,0,0,0,1.65,2.11c.38.21.49-.28.12-.48a2.66,2.66,0,0,1-1.12-1.33c0-.09-.07-.19-.09-.28a1.89,1.89,0,0,1,0-1,.58.58,0,0,1,.22-.34l0,0,0,0h.07a.45.45,0,0,1,.28,0,1.15,1.15,0,0,1,.45.3,2.41,2.41,0,0,1,.38.54,2.75,2.75,0,0,1,.17.29l0,.07a.31.31,0,0,1,.05.1s0,.05,0,.07h.56a4.18,4.18,0,0,0-.51-1,2.13,2.13,0,0,0-1.5-1,.86.86,0,0,0-.9.79A2.33,2.33,0,0,0,321.63,134.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,134.74a3.54,3.54,0,0,0,1.66,2.1c.37.21.48-.28.11-.48a2.62,2.62,0,0,1-1.12-1.33c0-.09-.06-.19-.08-.28a1.8,1.8,0,0,1,0-1,.61.61,0,0,1,.23-.34l0,0,.05,0h.08a.51.51,0,0,1,.27,0,1.11,1.11,0,0,1,.45.31,2.08,2.08,0,0,1,.38.53,1.78,1.78,0,0,1,.17.3l0,.07a.3.3,0,0,1,0,.1s0,0,0,.07h.57a4.49,4.49,0,0,0-.52-1,2.16,2.16,0,0,0-1.5-1,.86.86,0,0,0-.9.79A2.37,2.37,0,0,0,318.53,134.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.44,134.67a3.51,3.51,0,0,0,1.65,2.11c.37.21.48-.29.11-.48a2.71,2.71,0,0,1-1.12-1.33c0-.09-.06-.2-.08-.29a1.76,1.76,0,0,1,0-1,.6.6,0,0,1,.23-.35s0,0,0,0l.05,0h.08a.43.43,0,0,1,.27,0,1,1,0,0,1,.45.3,2.25,2.25,0,0,1,.39.54,2.69,2.69,0,0,1,.16.29l0,.07a.42.42,0,0,1,0,.1s0,0,0,.07h.56a4.1,4.1,0,0,0-.52-1,2.17,2.17,0,0,0-1.5-1,.88.88,0,0,0-.9.79A2.26,2.26,0,0,0,315.44,134.67Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.34,134.61a3.49,3.49,0,0,0,1.65,2.1c.37.21.48-.28.12-.48A2.68,2.68,0,0,1,313,134.9c0-.09-.06-.19-.08-.28a1.9,1.9,0,0,1,0-1,.55.55,0,0,1,.23-.34.07.07,0,0,0,0,0s0,0,0,0h.08a.56.56,0,0,1,.28,0,1.15,1.15,0,0,1,.44.3,2.72,2.72,0,0,1,.39.54c.06.09.11.19.17.3l0,.06a.49.49,0,0,1,0,.11s0,0,0,.06l.56,0a4.1,4.1,0,0,0-.52-1,2.09,2.09,0,0,0-1.49-1,.87.87,0,0,0-.91.79A2.26,2.26,0,0,0,312.34,134.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.24,134.54a3.5,3.5,0,0,0,1.65,2.1c.37.21.49-.28.12-.48a2.57,2.57,0,0,1-1.12-1.33c0-.09-.07-.19-.09-.28a1.9,1.9,0,0,1,0-1,.67.67,0,0,1,.23-.34l0,0,.05,0h.07a.46.46,0,0,1,.28,0,1,1,0,0,1,.45.3,2.36,2.36,0,0,1,.38.53l.17.3,0,.07.05.1s0,0,0,.07h.56a4.05,4.05,0,0,0-.51-1,2.19,2.19,0,0,0-1.5-1,.88.88,0,0,0-.91.79A2.38,2.38,0,0,0,309.24,134.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,134.47a3.52,3.52,0,0,0,1.65,2.11c.38.21.49-.28.12-.48a2.61,2.61,0,0,1-1.12-1.33c0-.09-.07-.19-.09-.28a1.9,1.9,0,0,1,0-1,.66.66,0,0,1,.23-.35l0,0,.05,0H307a.45.45,0,0,1,.28,0,1.15,1.15,0,0,1,.45.3,2.2,2.2,0,0,1,.38.54,2.75,2.75,0,0,1,.17.29l0,.07a.93.93,0,0,1,.05.1.25.25,0,0,1,0,.07H309a4.24,4.24,0,0,0-.51-1,2.15,2.15,0,0,0-1.5-1,.86.86,0,0,0-.9.79A2.22,2.22,0,0,0,306.14,134.47Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,134.41a3.51,3.51,0,0,0,1.66,2.1c.37.21.48-.28.11-.48a2.62,2.62,0,0,1-1.12-1.33c0-.09-.07-.19-.09-.28a1.89,1.89,0,0,1,0-1,.65.65,0,0,1,.22-.34l0,0s0,0,.05,0h.07a.54.54,0,0,1,.28,0,1.18,1.18,0,0,1,.45.31,2.36,2.36,0,0,1,.38.53,2.91,2.91,0,0,1,.17.3l0,.07a.19.19,0,0,1,.05.1s0,0,0,.07h.56a4.05,4.05,0,0,0-.51-1,2.13,2.13,0,0,0-1.5-1,.86.86,0,0,0-.9.79A2.37,2.37,0,0,0,303,134.41Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,134.34a3.52,3.52,0,0,0,1.66,2.1c.37.22.48-.28.11-.48a2.6,2.6,0,0,1-1.12-1.32c0-.09-.06-.2-.08-.29a1.76,1.76,0,0,1,0-1,.6.6,0,0,1,.23-.35l0,0,0,0h.08a.43.43,0,0,1,.27,0,1.08,1.08,0,0,1,.45.3,2,2,0,0,1,.38.54,1.69,1.69,0,0,1,.17.29l0,.07a.42.42,0,0,1,0,.1s0,.05,0,.07h.57a4.49,4.49,0,0,0-.52-1,2.19,2.19,0,0,0-1.5-1,.87.87,0,0,0-.9.79A2.37,2.37,0,0,0,299.94,134.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,134.27a3.48,3.48,0,0,0,1.65,2.11c.37.21.48-.28.11-.48a2.71,2.71,0,0,1-1.12-1.33c0-.09-.06-.19-.08-.28a1.8,1.8,0,0,1,0-1,.55.55,0,0,1,.23-.34s0,0,0,0l.05,0h.08a.43.43,0,0,1,.27,0,1,1,0,0,1,.45.3,2.46,2.46,0,0,1,.39.54,2.11,2.11,0,0,1,.16.3l0,.06a.49.49,0,0,1,0,.11s0,0,0,.06l.56,0a4.1,4.1,0,0,0-.52-1,2.11,2.11,0,0,0-1.5-1,.86.86,0,0,0-.9.79A2.22,2.22,0,0,0,296.85,134.27Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.75,134.21a3.49,3.49,0,0,0,1.65,2.1c.37.21.48-.28.12-.48a2.64,2.64,0,0,1-1.13-1.33c0-.09-.06-.19-.08-.28a1.9,1.9,0,0,1,0-1,.61.61,0,0,1,.23-.34l0,0,0,0h.08a.54.54,0,0,1,.28,0,1.08,1.08,0,0,1,.44.31,2.41,2.41,0,0,1,.39.53c.06.09.11.2.17.3l0,.07a.42.42,0,0,1,0,.1.15.15,0,0,1,0,.07h.56a4.1,4.1,0,0,0-.52-1,2.12,2.12,0,0,0-1.49-1,.87.87,0,0,0-.91.79A2.26,2.26,0,0,0,293.75,134.21Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.65,134.14a3.52,3.52,0,0,0,1.65,2.11c.37.21.49-.29.12-.48a2.61,2.61,0,0,1-1.12-1.33c0-.09-.07-.2-.09-.29a1.86,1.86,0,0,1,0-1,.66.66,0,0,1,.23-.35l0,0,.05,0h.07a.46.46,0,0,1,.28,0,1.15,1.15,0,0,1,.45.3,2.2,2.2,0,0,1,.38.54c.06.09.11.19.17.29l0,.07,0,.1s0,0,0,.07h.56a4.05,4.05,0,0,0-.51-1,2.15,2.15,0,0,0-1.5-1,.87.87,0,0,0-.91.79A2.34,2.34,0,0,0,290.65,134.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,145.69c-1.87,4.37-6.79,9.91-7.08,13.44a4.06,4.06,0,0,0,2.42,4.19s-3.43,1.89-3.16,5.13c.14,1.67,2.93,2.91,2.93,2.91s-2.69,1.63-2.27,4.5c.34,2.28,3.08,3.18,3.08,3.18s-1.85,2.77-.76,5c2.2,4.5,22,3.71,24.78-3.7,1.29-3.46-3.53-3-3.53-3s6.78-2.33,6.72-6.41-6.29-3.12-6.29-3.12,6.56-2.32,6.07-6.55c-.51-4.4-6.58-2.37-6.58-2.37s4.29-3.16,3.17-6.31c-1.84-5.21-9.92,1.75-14.31.89l-2.68-7.08Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.16,152.08c1.41-4.29-4-9.32-3.28-13.62,1-5.82,7.74-.42,9.52,7.91l.24,6.7Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,179.25a.05.05,0,0,0,0,.1,34.35,34.35,0,0,0,20.35-2c.21-.09.14-.46-.1-.4A70.43,70.43,0,0,1,288.22,179.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,171.4c-.07,0-.08.13,0,.14,6.79,1.34,15.37.48,22.07-3.58.23-.14.3-.5,0-.36C304.33,170,293.31,171.7,286.9,171.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.62,158.42c-6.58,3.65-13.66,4.81-21.11,5-.1,0-.09.14,0,.16,3.66.92,8.4.32,12-.45a19.72,19.72,0,0,0,9.19-4.45C308.85,158.56,308.76,158.35,308.62,158.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,114.39c-.39,1-4.22,7.71-9,7.71-3,0-2.28-10.33-2.28-10.33l-.05-.64-.7-9,11.2-5.1,1.61-.66s0,2.47,0,5.56v.44c0,.17,0,.34,0,.5,0,.46,0,.93,0,1.4s0,.71,0,1.08,0,.74,0,1.12A58.68,58.68,0,0,1,378.29,114.39Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.09,101.92A18.14,18.14,0,0,1,367,111.13l-.7-9,11.2-5.1,1.61-.66S379.08,98.83,379.09,101.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,89.21c-.94,15.83,8.43,18.18,11.85,18.38,3.1.18,13.67.4,16.25-15.24s-4.49-21.09-11.56-21.88S355,73.38,354.05,89.21Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.51,85.54a9.66,9.66,0,0,0,1.07-.22,1.74,1.74,0,0,0,1.05-.44.56.56,0,0,0,0-.69,1.41,1.41,0,0,0-1.38-.33,2.07,2.07,0,0,0-1.29.72A.6.6,0,0,0,356.51,85.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.87,85.62c-.37-.05-.71-.15-1.07-.23a1.85,1.85,0,0,1-1.05-.45.57.57,0,0,1,0-.69,1.4,1.4,0,0,1,1.38-.32,2.11,2.11,0,0,1,1.29.73A.61.61,0,0,1,366.87,85.62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,89.61s.08.06.08.1c-.06,1.08,0,2.33,1,2.71,0,0,0,.07,0,.06C364.48,92.28,364.36,90.63,364.59,89.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.58,88.51c1.74-.08,1.78,3.4.17,3.48S364.13,88.58,365.58,88.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.27,88.69c.31.19.61.54,1,.57s.74-.33,1-.69c0,0,.06,0,.06,0,0,.67-.23,1.36-.94,1.47s-1.13-.49-1.31-1.16C366,88.8,366.15,88.61,366.27,88.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.59,89.5s-.09,0-.09.1c.06,1.08-.06,2.32-1,2.7a0,0,0,0,0,0,.06C358.67,92.17,358.81,90.51,358.59,89.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.6,88.39c-1.74-.1-1.81,3.39-.2,3.48S359.06,88.47,357.6,88.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,88.61c-.28.18-.56.51-.89.52s-.65-.36-.89-.73c0,0,0,0-.06,0,0,.66.18,1.36.82,1.5s1-.43,1.19-1.09C357.07,88.72,357,88.53,356.87,88.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.52,98.21c-.25.27-.48.63-.87.68a2.8,2.8,0,0,1-1.18-.2,0,0,0,0,0,0,.06,1.43,1.43,0,0,0,1.4.5,1.13,1.13,0,0,0,.79-1C364.64,98.19,364.55,98.17,364.52,98.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,94.31s-.22,1.61-.22,2.37c0,.07.19.1.44.12,0,0,0,0,0,0a3.62,3.62,0,0,0,3.52-1.35c.05-.07,0-.15-.12-.1a5.48,5.48,0,0,1-3.3.94c-.05-.21.47-2.75.35-2.76a7,7,0,0,0-1.72.39c.36-3.37,1.27-6.65,1.58-10a.11.11,0,0,0-.2-.05,54.49,54.49,0,0,0-2.16,10.72C358.13,95,359.7,94.44,360,94.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,91.75c-2.6.38-3.57-5-3.57-5s-5.29.37-7.56-7.12a11.76,11.76,0,0,0,2.78,6.13s-9.41-.35-13.87-7.9c0,0,1.84,3.87,3.4,5.19a11,11,0,0,1-6.11-3.88s-1.33,4.62-2.51,6c0,0-2.16-7.94,1-12.26,6.64-9.09,18.49-1.94,18.49-1.94s6.48.69,9,5.41C387,83.6,382.08,91.75,382.08,91.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.49,91.51s3.33-5,5.61-3.87-.13,8.42-2.74,9.47a2.67,2.67,0,0,1-3.63-1.34Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36,89.7a0,0,0,0,1,0,.07c-1.82.8-2.75,2.54-3.38,4.34a1.48,1.48,0,0,1,2.2-.47c.05,0,0,.11-.05.1a1.66,1.66,0,0,0-1.8.63,8.34,8.34,0,0,0-.83,1.49c-.08.17-.38.09-.32-.11v0C380.09,93.36,381.83,90,384.36,89.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.05 437.53 122.95 437.53 122.95 427.66 131.52 417.66 222.05 417.66 222.05 437.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.96 437.53 222.05 437.53 222.05 417.66 250.96 417.66 260.96 427.6 260.96 437.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.24,
    y: 311.62,
    width: 15.3,
    height: 106.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.53,
    y: 311.62,
    width: 34.36,
    height: 106.04,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.97,
    y: 387.89,
    width: 44.54,
    height: 6.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.51,
    y: 387.89,
    width: 17.49,
    height: 6.92,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 281.14 258.99 281.14 267.21 263.51 274 263.51 265.78 281.14",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,255H267.1s.4,11.85-8.41,11.85a6.15,6.15,0,0,1-5.77-3.34s3.24,6.89,9.22,6.89H275.2C278.75,270.44,286.15,268,286.85,255Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,255h19.76s-.41,11.85,8.4,11.85a6.16,6.16,0,0,0,5.78-3.34s-3.24,6.89-9.22,6.89H262.54C259,270.44,251.6,268,250.89,255Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,308.64a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,240.23,308.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.88 309.12 237.32 308.16 257.04 276.22 262.71 276.22 262.71 278.05 258.06 278.05 238.88 309.12",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,238.11a5.36,5.36,0,1,1-5.36-5.36A5.36,5.36,0,0,1,173.64,238.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.28,
    cy: 238.11,
    r: 2.77,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.61,297.66a5.36,5.36,0,1,1-5.35-5.36A5.36,5.36,0,0,1,243.61,297.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.26,
    cy: 297.66,
    r: 2.77,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.39 298.42 212.38 240.13 168.28 240.13 168.28 236.09 215.09 236.09 240.12 296.89 236.39 298.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.96,
    y: 271.52,
    width: 126.78,
    height: 19.07,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.58 271.52 112.96 271.52 69.99 165.44 158.61 165.44 201.58 271.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.58 271.52 134.44 271.52 91.47 165.44 158.61 165.44 201.58 271.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.18,
    y: 271.52,
    width: 69.55,
    height: 19.07,
    transform: "translate(409.91 562.1) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.74,
    y: 124.62,
    width: 82.87,
    height: 40.82,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.47,
    y: 124.62,
    width: 67.14,
    height: 40.82,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,145.77c0,11.07-10.71,18.6-10.71,18.6h-62v-37.2h62S167,134.7,167,145.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.36,164.36V127.17s10.71,7.53,10.71,18.6S94.36,164.36,94.36,164.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.05,177.07c4.79-.2,9.59-.3,14.38-.38s9.59-.07,14.38-.11,9.59,0,14.39.11l7.19.14c2.39.08,4.79.13,7.19.24-2.4.12-4.8.17-7.19.25l-7.19.14c-4.8.08-9.59.08-14.39.11s-9.58,0-14.38-.11S107.84,177.28,103.05,177.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,202.6c4.79-.21,9.58-.31,14.38-.39s9.59-.07,14.38-.11,9.59,0,14.38.11l7.19.14c2.4.09,4.8.13,7.2.25-2.4.11-4.8.16-7.2.24l-7.19.14c-4.79.08-9.58.08-14.38.12s-9.59,0-14.38-.12S117.75,202.8,113,202.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.86,228.12c4.8-.21,9.59-.3,14.39-.38s9.58-.08,14.38-.12,9.59,0,14.38.12l7.19.13c2.4.09,4.8.14,7.19.25-2.39.11-4.79.16-7.19.25l-7.19.13c-4.79.08-9.59.08-14.38.12s-9.59,0-14.38-.12S127.66,228.33,122.86,228.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.77,253.64c4.8-.2,9.59-.3,14.38-.38s9.59-.08,14.39-.12,9.58,0,14.38.12l7.19.14c2.4.08,4.79.13,7.19.24-2.4.12-4.79.16-7.19.25l-7.19.14c-4.8.08-9.59.07-14.38.11s-9.59,0-14.39-.11S137.57,253.85,132.77,253.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.96,
    y: 290.58,
    width: 131.11,
    height: 15.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.23 165.44 75.76 165.44 131.49 306.16 112.96 306.16 57.23 165.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.74 124.62 57.23 131.89 57.23 165.44 75.74 165.44 75.74 124.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 306.16,
    width: 74.48,
    height: 5.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.51,
    y: 308.89,
    width: 59.57,
    height: 10.25,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,125.34c8.46,8.24,5.26,19.27,8.61,25.58,2.05,3.86,9.24,8.25,10.45,12.62,2,7.18-4.13,9.33-3,13.23,1.54,5.53,8.81,5.57,9.55,14.51S197.28,209,174,210.09s-35.44-8.19-35.79-15.75,7.5-9.58,8.38-15.15c.56-3.57-4-6.36-3.85-13s6.74-8.34,8-13.89-.82-19.34,7.85-25.77S177.12,121.27,181.3,125.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,125.47a19.12,19.12,0,0,1,5.5,7.24,41.13,41.13,0,0,1,2.73,9.29,25.28,25.28,0,0,0,1.45,5.56,13.89,13.89,0,0,0,2.86,4c2.36,2.42,5.23,4.32,7.31,7,2,2.54,3.43,5.87,2.37,9.09-.57,1.76-1.84,3.14-2.68,4.76s-1.2,3.47.07,4.87c1.09,1.19,2.73,1.81,4,2.81a14.78,14.78,0,0,1,3.16,3.49,11.34,11.34,0,0,1,1.56,9c-1.81,7.1-8.82,10.76-15.21,12.94l-2.69.89c-.13,0-.24-.16-.09-.21,6.42-2.4,13.89-5.22,16.73-12.06a10.55,10.55,0,0,0-.48-9.34,13.39,13.39,0,0,0-3.09-3.69c-1.19-1-2.61-1.67-3.83-2.63a4.29,4.29,0,0,1-1.73-3.93,10.47,10.47,0,0,1,2-4.48,8.57,8.57,0,0,0,1.78-4.75,9.37,9.37,0,0,0-1.55-4.74c-1.77-2.88-4.54-4.87-7-7.12a15.63,15.63,0,0,1-5.13-8.14c-.38-1.68-.57-3.39-.87-5.09a46.79,46.79,0,0,0-1.09-4.65,21.78,21.78,0,0,0-4.38-8.37,12.08,12.08,0,0,0-1.81-1.69C180.09,125.53,180.18,125.41,180.25,125.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.53,188.76a8.65,8.65,0,0,1,1.81-3.26c.87-1,1.9-1.77,2.85-2.65a6.63,6.63,0,0,0,2.09-3,6.28,6.28,0,0,0-.75-4.23,30.66,30.66,0,0,1-1.82-4.16,14.64,14.64,0,0,1-.6-4.37,14.84,14.84,0,0,1,2.87-8.45c.87-1.24,1.84-2.41,2.72-3.64a18.85,18.85,0,0,0,2.33-4.36c1.26-3.42,1.72-7.07,2.8-10.55a54.59,54.59,0,0,1,4.42-10.24c0-.08.16,0,.12.08a47.91,47.91,0,0,0-3.89,9.26c-.93,3.05-1.41,6.19-2.16,9.28a23.22,23.22,0,0,1-1.46,4.43,24,24,0,0,1-2.25,3.73c-1.73,2.45-3.5,4.86-4.12,7.85a14.14,14.14,0,0,0,.94,8.75c1.07,2.38,2.61,5,1.37,7.64-1,2.22-3.3,3.45-4.86,5.25a9.14,9.14,0,0,0-2,7.2c.83,6.56,7.11,10.18,13.17,10.89a.15.15,0,0,1,0,.29c-5.28-.4-10.87-3.08-13-8.18A11.24,11.24,0,0,1,137.53,188.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,176.37c9,15,22.17,29.82,28.47,30.51,5.07.55,37.9-13.31,40.43-15.76,2.17-2.11-9.45-22.47-12.58-21.63-5.25,1.42-24.9,14.46-26.36,14s-12.39-8.59-23.82-16.1C167.34,160.23,165.88,166,172.15,176.37Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,193.16c2.82-1.1,16.4-7.28,19.49-9.78s11.45-10.33,9.78-12.89-4.31-.46-4.31-.46,3-3.86,1.09-6.29-5.9,1-5.9,1,2.8-4.2.71-6.48-5.52,1.81-5.52,1.81,2.74-3.72.23-4.87c-3-1.39-7.3,6-10.91,8.53-.82.57-17.47,10.33-17.47,10.33Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.2,159.71c-3.16,5.45-5.48,7.28-11,10.16-.1.06,0,.23.07.18,5.64-2.33,8.89-4.21,11.18-10.21C253.58,159.55,253.35,159.45,253.2,159.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,164.28c-3.77,5.37-6.28,7.39-11.81,10.83-.08,0,0,.19.08.14,5.71-2.92,8.91-4.87,12-10.74C258.33,164.25,258.12,164,258,164.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.23,170.2c-4,4.94-6.67,7.27-12.47,9.92a.11.11,0,1,0,.08.21c6.18-2.12,9.5-5,12.53-10C262.58,170,262.49,169.89,262.23,170.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,174.31s4.54-8,6.79-10.79,14.4-9.9,16.09-7.36c2.19,3.27-4,8.78-7.4,11.09,0,0,5.06,7.57,1.47,12.49S218.83,174.31,218.83,174.31Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,157.25c-.16,4.43-4.81,7.16-7.93,9.64a.36.36,0,0,0,0,.6c1.91,3.32,3.64,8.55,1.93,12.21a.09.09,0,0,0,.16.09c2.37-3.67,1.09-8.95-1.24-12.45,3.24-2.49,7.78-5.44,7.11-10.09C242.06,157.23,242,157.22,242,157.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.88,174.08,233,197.41s-26.68,12.43-34.29,9.48-22.94-23.18-28.8-33.75,1-11.64,11.31-4.61,20.65,14.68,20.94,14.66S217.88,174.08,217.88,174.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.15,198.92c-2-3.46-10.53-17.33-12.58-20.19-.15-.2-.31-.15-.19.08C219,189.34,223.91,195.71,226,199,226.06,199.08,226.2,199,226.15,198.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,170.51c2.09,5.55,9,15.56,9,15.56l20.91-7.37s-14.92-12.13-24.88-15.55C168.56,161.78,165.42,164.89,167.54,170.51Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,183.19c3-1.3,6.07-2.55,9.18-3.67,1.55-.56,3.1-1.09,4.67-1.6s3.18-.87,4.73-1.4c.09,0,.13.11,0,.14-1.57.45-3.1,1.12-4.66,1.65s-3.11,1.08-4.66,1.64c-3.09,1.1-6.19,2.2-9.26,3.38C175.62,183.36,175.58,183.23,175.67,183.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,182.19l-11,3.88s-6.89-10-9-15.56a8.08,8.08,0,0,1-.51-4.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,408.61c-2.41.81-71.36.94-74-.72-1-.62-1.6-10.66-2-22.81-.09-2.63-.16-5.34-.21-8.09a339.67,339.67,0,0,0-3.22-36.85l46.12-.22,1.95,36.85-.19,8.09s26.42,11.76,29.11,13.89S323,407.8,320.61,408.61Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83,390.54c.38,9.57.94,16.83,1.79,17.35,2.63,1.66,71.59,1.53,74,.72s.26-7.73-2.41-9.86c-1.19-.94-6.94-3.73-13-6.57h0s6,4.85,3.79,5.54C297.32,401.35,257.5,393.26,244.83,390.54Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24,216.38h25.08L187.41,231s63.07-.36,80,18.44c20.61,23,21.75,123.9,21.75,123.9H244.31s-6.76-81.78-12-88.6-65.57-4.84-81.94-19.33c-15.21-13.47-7.82-52.71-9-49Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,430.43c-2.53.28-69.95-14.16-72.17-16.34-.85-.82.68-10.76,2.87-22.72.48-2.58,1-5.25,1.51-7.95,3.4-17.55,7.42-36.09,7.42-36.09l45.13,9.53-8.67,35.83-1.89,7.87s23.34,17.07,25.52,19.72S263,430.15,260.5,430.43Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.13,347.33s-4,18.54-7.42,36.09c-.53,2.71-1,5.37-1.5,7.95-.35,1.85-.66,3.64-1,5.38-1.65,9.44-2.64,16.65-1.92,17.34,2.22,2.18,69.64,16.62,72.17,16.34s1.89-7.5-.28-10.14c-1-1.17-6-5.12-11.33-9.17h0c-6.83-5.18-14.17-10.55-14.17-10.55l1.9-7.87,8.66-35.83Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,396.75c-1.65,9.44-2.64,16.65-1.92,17.34,2.22,2.18,69.64,16.62,72.17,16.34s1.89-7.5-.28-10.14c-1-1.17-6-5.12-11.33-9.17h0s4.85,6,2.53,6.22C239.26,418.42,202.06,402.09,190.25,396.75Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08,382.42l-44.48-8.56s18.08-84.27,14.79-88.5c-5.41-7-51.51-5.94-71.84-20-16.51-11.46-2.93-49-2.93-49h43.93s4.33,8.83,5.4,12.95c0,0,52.05,10.5,69.34,27.45C271.12,274.25,239.08,382.42,239.08,382.42Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,261.73a22.2,22.2,0,0,0-6.92-8.68,45.09,45.09,0,0,0-9.88-5.45c-.85-.37-1.72-.73-2.58-1.09-.21-.09-.38.21-.17.31,6.53,3.32,13.59,6.89,17.22,13.56s3.33,14.9,2.88,22.32c-.54,9-1.6,17.94-3,26.84s-3,17.68-4.89,26.47-3.8,17.65-5.7,26.48c-.24,1.1-.43,2.21-.67,3.31,0,.1.13.14.15,0,2.38-8.88,4.81-17.73,6.87-26.68s3.89-17.85,5.43-26.85,2.67-18.12,3.3-27.25C259.62,277.35,260.2,269,257,261.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.78,282.54c2,.2,1.2-41.9,37.45-34,0,0,2.2-4.47,5.26-5.69,6.75-2.69,11.35-.32,11.35-.72s-6.32-8.21-42-12.09c-12.22-1.33-21.57-1.92-24.57-3.58-2.09-1.16-9.23-10.08-9.23-10.08l-46.45,0s-7.86,19.12-5.25,35.91S156.64,277.9,202.78,282.54Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,242a137.53,137.53,0,0,0-30.25-2c-2.91.15-5.8.43-8.69.7-.1,0-.1.16,0,.16,5-.27,10.07-.25,15.09-.19s10.06.28,15.07.68c2.92.23,5.83.46,8.75.78A.06.06,0,0,0,232,242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,238.3c-2.76,0-5.51,0-8.26.15s-5.49.5-8.23.83a.08.08,0,1,0,0,.15c2.73-.27,5.49-.4,8.23-.56s5.5-.33,8.25-.44C229.11,238.42,229.11,238.3,229,238.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,216.38l-46.71.22S142.9,180.3,155,167c5.5-6.07,11-5.24,15.68-1.46,1.17.94,14.82,17.89,16,26.34.81,5.65-4.59,10.7-4.59,10.7Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36,202.32A21.7,21.7,0,0,0,171.7,205c-1,.6-2.08,1.22-3.09,1.87s-2.12,1.42-3.24,2c-.09,0,0,.18.09.14,1.07-.54,2.16-1,3.22-1.62s2.08-1.22,3.13-1.81a34.81,34.81,0,0,1,6.59-3.11C178.47,202.41,178.43,202.31,178.36,202.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.27,204.33c-3,.09-5.66,1.31-8.34,2.45-.09,0-.05.19,0,.15a30.49,30.49,0,0,1,8.29-2.43C180.38,204.48,180.38,204.33,180.27,204.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,165.87c.21,1.06,5,8,9.83,8,1.56,0,1.79-8.59,1.79-8.59l.16-.63,2.25-8.78-10.19-7-1.47-.93s-.46,2.44-1,5.49c0,.15-.05.29-.08.44s-.07.33-.09.49c-.09.46-.17.92-.25,1.39s-.12.69-.17,1.07-.11.73-.16,1.11A57.33,57.33,0,0,0,162.94,165.87Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.31,153.4a18.19,18.19,0,0,0,10.41,11.21l2.25-8.78-10.19-7-1.47-.93S164.85,150.35,164.31,153.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.11,140.22c3.54,15.52-5.36,19.39-8.71,20.15-3,.69-13.48,2.65-18.6-12.43s1-21.63,7.85-23.57S185.57,124.69,189.11,140.22Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,137.88a10.09,10.09,0,0,1-1.1,0,1.79,1.79,0,0,1-1.12-.22.55.55,0,0,1-.14-.68,1.39,1.39,0,0,1,1.29-.6,2.05,2.05,0,0,1,1.41.46A.6.6,0,0,1,187,137.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.75,140.32c.36-.12.67-.29,1-.44a1.77,1.77,0,0,0,.94-.64.57.57,0,0,0-.14-.68,1.39,1.39,0,0,0-1.42,0,2,2,0,0,0-1.12,1A.6.6,0,0,0,176.75,140.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74,143.28s-.07.07-.06.12c.28,1,.42,2.29-.46,2.86,0,0,0,.07,0,.06C180.37,145.89,180.17,144.23,179.74,143.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,142.4c-1.73.26-1.08,3.7.52,3.45S180,142.18,178.54,142.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,142.7c-.26.26-.49.65-.85.76s-.79-.18-1.13-.48c0,0-.06,0,0,.05.11.67.49,1.29,1.22,1.26s1-.7,1-1.4C178.15,142.76,178,142.6,177.9,142.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,142s.09,0,.1.08c.15,1.07.52,2.28,1.55,2.46,0,0,0,.06,0,.06C185.83,144.66,185.37,143.06,185.39,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.14,140.74c1.69-.44,2.45,3,.88,3.38S184.72,141.1,186.14,140.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,140.8c.31.12.65.39,1,.34s.57-.48.73-.89c0,0,0,0,.06,0,.17.65.1,1.38-.5,1.65s-1.09-.23-1.39-.85C186.72,141,186.78,140.75,186.9,140.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.08,152.08c.3.21.6.52,1,.5a2.86,2.86,0,0,0,1.11-.43,0,0,0,0,1,.06,0A1.44,1.44,0,0,1,182,153a1.16,1.16,0,0,1-1-.83C181,152.08,181,152.05,181.08,152.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.76,147.34s.54,1.55.69,2.3c0,.07-.16.14-.42.2h0a3.62,3.62,0,0,1-3.72-.64c-.07-.06,0-.16.09-.12a5.56,5.56,0,0,0,3.44.28c0-.22-1-2.62-.89-2.65a6.65,6.65,0,0,1,1.77,0c-1-3.24-2.56-6.3-3.54-9.55a.11.11,0,0,1,.19-.09,55.31,55.31,0,0,1,4.25,10.13C186.74,147.66,185.08,147.41,184.76,147.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,149.7a4,4,0,0,1-1.3,1.49,1.79,1.79,0,0,1-1,.27c-.8-.05-1-.74-.93-1.36a4.51,4.51,0,0,1,.16-1A5,5,0,0,0,184.42,149.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.12,151.19a1.79,1.79,0,0,1-1,.27c-.8-.05-1-.74-.93-1.36A1.79,1.79,0,0,1,183.12,151.19Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,148.89a6.45,6.45,0,0,0,2.82-5.72,16.94,16.94,0,0,0,6-6.46c-.06.34-.48,2.75-.73,4,9.57-3.26,11.53-11.23,11.53-11.23a17.08,17.08,0,0,1,5.19,5.62s-.8-6.05-4.49-9.64c-4.51-4.4-17.53-3.88-22.53,3.43C155.08,136.75,162.66,148.89,162.66,148.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,138a18.28,18.28,0,0,1-4.78,2.58s0,0,0,0a15.66,15.66,0,0,0,6.59-5.41,14.49,14.49,0,0,0,1.69-3.27,10.32,10.32,0,0,0,.77-3.94.08.08,0,1,1,.15,0,12.17,12.17,0,0,1-.22,4,11.1,11.1,0,0,1-1.71,3.57A12.6,12.6,0,0,1,178,138",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07,153.67a3.07,3.07,0,0,0,.76.09,2.54,2.54,0,0,0,.75-.08,2.31,2.31,0,0,0,.86-.42,2.76,2.76,0,0,0,.54-.54,2.93,2.93,0,0,0,.47-1l-1.45-4.1s-4.13-4.44-6.19-2.91S160.31,153.06,163.07,153.67Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88,146.66s0,.06,0,.07c1.94.49,3.14,2.06,4.06,3.74a1.48,1.48,0,0,0-2.26-.1s0,.11.07.09a1.65,1.65,0,0,1,1.88.33,7.77,7.77,0,0,1,1.07,1.34c.11.15.39,0,.3-.16l0,0C164.71,149.58,162.43,146.55,159.88,146.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,153a.74.74,0,0,0,.94.45.74.74,0,1,0-.49-1.39A.74.74,0,0,0,163.2,153Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,152.08a.51.51,0,0,0,.66.32.52.52,0,1,0-.34-1A.51.51,0,0,0,161.55,152.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8,171.58c-8.61,15.59-19.16,37.72-16.62,45.33,1.86,5.57,27.9,22.82,36.2,28,3,1.86,18.8-17.5,15.83-19.79-3.86-3-31.17-18.2-31.13-20.5,0-1.3,3.83-21,5.07-29.7C163.47,158.65,154.82,166.12,151.8,171.58Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,221.52s10,.56,16.54,1.24c3.64.38,9.82,1.58,12.37,3.08,3.81,2.25,18.32,14.07,15.53,17.65-2.53,3.24-13.7-8.5-13.7-8.5s12.32,10.85,8.56,14.19-14.62-11.6-14.62-11.6,12.41,11.43,8,14.27C209.78,254,199.18,241,199.18,241s10.6,9.9,7.26,12.25c-3.7,2.59-14.23-8.78-14.23-8.78-9.5,4.55-18.64,2.29-20.83.44C170.5,244.18,180.45,221.52,180.45,221.52Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.17,231c1.49,1.23,3,2.45,4.39,3.8s2.71,2.76,4,4.23a33.07,33.07,0,0,1,4.31,6.19c-2.41-3.79-7.27-8.7-8.65-10.05s-2.69-2.77-4.07-4.11C207.08,231,207.13,230.94,207.17,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,235.86c1.84,1.64,3.72,3.21,5.49,4.93s3.28,3.5,4.92,5.33c.12.14,0,.17-.13,0-1.71-1.77-3.42-3.27-5.15-5s-3.39-3.57-5.17-5.24A0,0,0,1,1,202.2,235.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,239.29a55.09,55.09,0,0,1,7.82,8.19c.12.14,0,.15-.16,0-2.55-2.77-4.53-5-7.74-8.1C197.05,239.35,197.12,239.24,197.18,239.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,221l-16.91,21s-29.36-17.51-31.08-26.91c-2.07-11.23,11.71-34.44,18.54-44.65s11.81-6.43,9.57,6.18-5.41,27.67-4.54,28.42S181.7,221,181.7,221Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.92,237.21c2.7-2.93,13.31-15.3,15.42-18.13.14-.19,0-.33-.13-.15A208.61,208.61,0,0,0,160.8,237.1C160.74,237.17,160.85,237.28,160.92,237.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,191.47l22.45-2.81s1.32-11.3,1.17-17.65c-.19-8.41-3.36-10.3-10-2.39C148.38,173.92,139.14,191.47,139.14,191.47Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.37,189a21,21,0,0,1,2.18-.36c.13-1.33.23-2.67.37-4,.07-.66.15-1.33.24-2s.17-1.57.26-2.21c0-.1.14-.1.14,0,0,.85-.08,1.48-.11,2.22,0,.52-.06,1-.1,1.56,0-.13.09-.26.13-.39.22-.7.5-1.37.69-2.08a.07.07,0,1,1,.13,0c-.21.7-.34,1.42-.54,2.13a10.14,10.14,0,0,1-.51,1.59c-.08,1.12-.05,2.39-.2,3.49a18.82,18.82,0,0,1-2.67.07A0,0,0,0,1,159.37,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,189.05c3.24-.63,6.48-1.22,9.75-1.66,1.63-.22,8.2-.77,9.83-1,.09,0,.1.12,0,.14-2,.43-8.46,1.25-10.09,1.47-3.26.43-6.24.65-9.49,1.15C141.07,189.21,141.07,189.07,141.15,189.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6,
    cy: 238.11,
    r: 5.35,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6,
    cy: 238.11,
    r: 2.77,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,297.66a5.36,5.36,0,1,1-5.36-5.36A5.36,5.36,0,0,1,170.93,297.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.57,
    cy: 297.66,
    r: 2.77,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.71 298.42 139.7 240.13 95.6 240.13 95.6 236.09 142.41 236.09 167.44 296.89 163.71 298.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.97 281.14 178.18 281.14 186.4 263.51 193.19 263.51 184.97 281.14",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,255H186.29s.4,11.85-8.41,11.85a6.16,6.16,0,0,1-5.78-3.34s3.25,6.89,9.22,6.89h13.07C197.94,270.44,205.33,268,206,255Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.08,255h19.75s-.4,11.85,8.41,11.85a6.16,6.16,0,0,0,5.78-3.34s-3.25,6.89-9.22,6.89H181.73C178.18,270.44,170.79,268,170.08,255Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.29,
    cy: 308.64,
    r: 2.13,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.06 309.12 156.51 308.16 176.23 276.22 181.9 276.22 181.9 278.05 177.25 278.05 158.06 309.12",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237,126.5a18,18,0,0,1-30,11.36l-9,1.32,4.49-7.77A18,18,0,1,1,237,126.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,126.5a18,18,0,0,1-3.62,9.1,19.43,19.43,0,0,1-1.63,1.88,20.49,20.49,0,0,1-1.89,1.6,17.56,17.56,0,0,1-4.34,2.41,17.75,17.75,0,0,1-4.83,1.16,17.37,17.37,0,0,1-2.5,0,14.79,14.79,0,0,1-2.48-.25,18.21,18.21,0,0,1-8.89-4.39l.22.06-9,1.38-.65.1.33-.57,4.47-7.78,0,.3a18.14,18.14,0,0,1,1.1-16,18.53,18.53,0,0,1,5.63-6,18.24,18.24,0,0,1,15.78-2.13,18.44,18.44,0,0,1,6.93,4.25A18.05,18.05,0,0,1,237,126.5Zm0,0a17.74,17.74,0,0,0-20.36-19.43,17.54,17.54,0,0,0-7.42,2.93,18.36,18.36,0,0,0-5.37,5.86,17.64,17.64,0,0,0-2.28,7.6,18,18,0,0,0,1.26,7.82l.07.16-.09.15-4.52,7.75-.32-.48,9-1.26h.13l.08.08a17.73,17.73,0,0,0,8.6,4.43,15.47,15.47,0,0,0,2.44.29,16.83,16.83,0,0,0,2.46,0,17.93,17.93,0,0,0,4.79-1,17,17,0,0,0,4.34-2.34,22,22,0,0,0,1.89-1.58,19.2,19.2,0,0,0,1.63-1.86A17.86,17.86,0,0,0,237,126.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,124.65a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,213,124.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,124.65a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,220.86,124.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,124.65A1.7,1.7,0,1,1,227,123,1.7,1.7,0,0,1,228.74,124.65Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients3);
export default __webpack_public_path__ + "static/media/Patients3.777a8204d05346033e3bc44e57f12ba4.svg";
export { ForwardRef as ReactComponent };